import Button from './_button.js'
import FlexPane from './_flex-pane.js'
import Popup from './_popup.js'
import AbsolutePane from './_absolute-pane.js'
import ImageButton from './_image-button.js'

export default {
  name: 'Popover',
  values: {
    button: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: 0,
            alignSelf: 'flex-start',
            alignItems: 'center',
            minWidth: '40px',
            minHeight: '40px',
          },
        },
      },
    },
    textContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    popup: {
      configSet: Popup,
      configValues: {
        container: {
          style: {
            width: '296px',
            top: '38px',
            left: 0,
          },
        },
        content: {
          style: {
            base: {
              alignItems: 'center',
              padding: '0px',
            },
            hidden: {
              transform: 'translateY(2px)',
            },
          },
        },
        arrowhead: {
          direction: 'up',
        },
      },
    },
    closeButtonContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          right: 0,
          top: 0,
        },
      },
    },
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '16px',
        },
      },
    },
    closeButton: {
      configSet: ImageButton,
      configValues: {
        button: {
          style: {
            base: {
              alignItems: 'center',
              flexBasis: '32px',
              minWidth: '32px',
              minHeight: '32px',
            },
          },
        },
        buttonIcon: {
          src: 'close',
          style: {
            minWidth: '8px',
            minHeight: '8px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
